import { getGeoOverrideHeaders } from 'src/common/helpers/slices';
import type { ApiResponse, PlanPricingData } from 'src/common/interfaces';
import { apiSlice } from 'src/features/api/api-slice';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSubscriptionPricing: builder.query<ApiResponse<PlanPricingData>, boolean>({
      query: (includeAll) => ({
        url: `payments/cost?includeAll=${includeAll.toString()}`,
        method: 'GET',
        headers: getGeoOverrideHeaders(),
      }),
    }),
  }),
});

export const { useGetSubscriptionPricingQuery } = extendedApiSlice;
